// extracted by mini-css-extract-plugin
export default {"link":"_b94ff814"};